export enum ActorName {
  SwapPool = "SwapPool",
  SwapFactory = "SwapFactory",
  SwapNFTCanister = "SwapNFT",
  Position = "PositionIndex",
  PassCodeManager = "PassCodeManager",
  LimitTransaction = "LimitTransaction",

  SwapGraphRecord = "BaseDataStructure",
  SwapGraphPool = "Pools",
  SwapGraphToken = "Token",
  SwapTicket = "Ticket",
  GraphICP = "ICPPrice",
  TVL = "TVL",

  TokenList = "TokenList",
  AllTokenOfSwap = "AllTokenOfSwap",

  Token = "token",
  WICP = "wicp",

  FarmController = "FarmController",
  Farm = "Farm",
  FarmStorage = "FarmStorage",
  FarmIndex = "FarmIndex",

  NFTCanisterController = "V3NFTCanisterController",
  NFTCanister = "NFTDynamicCanister",
  NFTTradeCanister = "V3TradeCanister",
  NFTTradeStat = "V3TradeStat",

  LaunchpadCanister = "LaunchpadCanister",
  LaunchpadController = "LaunchpadController",
  LaunchpadManager = "LaunchpadManager",
  LaunchpadStorage = "LaunchpadStorage",

  ClaimController = "ClaimController",
  ClaimStorage = "ClaimStorage",

  VotingController = "VoteController",
  VotingCanister = "VoteProjectCanister",
  VotingFileCanister = "VoteFileCanister",

  StakingTokenController = "StakingTokenController",
  TokenPool = "TokenPool",
  TokenPoolStorage = "TokenPoolStorage",
  StakeIndex = "StakeIndex",

  V1TokenPoolController = "V1TokenPoolController",
  V1TokenPool = "V1TokenPool",
  V1TokenPoolStorage = "V1TokenPoolStorage",

  GlobalIndex = "GlobalIndex",
  NodeIndex = "NodeIndex",
  BaseIndex = "BaseIndex",

  LiquidityLocks = "LiquidityLocks",

  Setting = "Setting",

  SocialMedia = "SocialMedia",
  AddressBook = "AddressBook",
  PriceAlerts = "PriceAlerts",
}
